import { useSubheader } from "../../../../_metronic/layout";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { paymentReducerActions } from "..";

import { Row, Col, Card, Button, Modal, ModalBody, Spinner } from "react-bootstrap";
import { XCircle, Back } from "react-bootstrap-icons";


export const PaymentFail = (props) => {
  const subheader = useSubheader();
  const dispatch = useDispatch();
  const history = useHistory();

  const { payment, catalogue } = useSelector( (state) => state );

  subheader.setTitle("Payment Failed");

  const { creatingPayment } = payment;

  const { selectedServiceItem:item } = catalogue;

  window.onpopstate = () => {
    dispatch(paymentReducerActions.resetState());
    history.push('/catalogue-management/region');
  };

  useEffect(() => {
    dispatch(paymentReducerActions.resetOrderInfo());
  }, [dispatch]);

  const redirect = () => {
    history.push('/catalogue-management');
  }; 


  return (
    <Card>
        <Modal show={creatingPayment} aria-labelledby="contained-modal-title-vcenter" centered >
            <ModalBody className="d-flex align-items-center">
                <Spinner animation="grow" size="lg" variant="warning" /> <span className="pl-5"> Retriving your payment results... </span>
            </ModalBody>
        </Modal>
        <Card.Header>
            <Row>
            <Col lg={1} md={12} sm={12} className="d-flex justify-content-center">
                <XCircle size={60} color="red" className="mr-5" />
            </Col>
            <Col lg={11} md={12} sm={12}>
                <Row> <h5> <b> An error has occured while processing your payment. </b> </h5> </Row>
                <Row> Please try again to make payment for - { item.serv_name }: { item.description } </Row>
            </Col>
            </Row>
        </Card.Header>
        <Card.Body>
            <Button variant="secondary" onClick={redirect}>
                <Back size={15} /> Return to Service Selection
            </Button>
        </Card.Body>
    </Card>
  );
};
